import { PRODUCT_QUANTITY } from '../actions';
import '../global';

const initialState = getCartInfo().products.reduce( ( acc, product ) => {
	acc[ product.iMIS_code ] = product.quantity;
	return acc;
}, {} );

export default function product_quantity_reducer( state = initialState, action ) {
	switch ( action.type ) {
		case PRODUCT_QUANTITY:
			return { ...state, ...action.payload };
		default:
			return state;
	}
}